import React from "react";
import { FormRepository, PageRepository, WebsiteRepository } from "../../repository";
import StandardFormComponent from "../basics/form/StandardFormComponent";
import { withRouter } from 'react-router-dom';
import Form from "../../models/form/Form";
import FormFormError from "./errors/FormFormError";
import StandardTextFormEditorComponent from "../basics/form/StandardTextFormEditorComponent";
import FormFieldFormComponent from "./FormFieldFormComponent";
import FormToastComponent from "../basics/FormToastComponent";
import { FormHelper } from "../../helpers";
import FormattedMessageString from "../basics/FormattedMessageString";
import Website from "../../models/website/Website";

class FormFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            model: props.model !== undefined ? props.model : new Form(),
            loading: true,
            isEdit: false,
            pages: [],
            settings: {}
        };

        this.table_ref = React.createRef();
    }


    componentDidMount() {
        let promises = [
            PageRepository.all(),
            WebsiteRepository.get(Website.get()),
        ];

        if (this.props.get_promise) {
            promises.push(this.props.get_promise);
        }

        Promise.all(promises)
            .then(result => {
                let pages = result[0];
                let website = result[1];
                let form = result[2];

                let pagesList = [];
                if (pages !== undefined) {
                    pagesList = pages.map(page => {
                        return {
                            value: page.page.id,
                            label: '-'.repeat(page.index) + " " + page.title
                        }
                    });
                }

                let model = new Form();
                if (form !== undefined && form) {
                    model = Form.fromJson(form.form, this.props.match.params.language);
                }

                if (website.addons.mailchimp.enabled) {
                    website.addons.mailchimp.lists = Object.keys(website.addons.mailchimp.lists).map(id => {
                        return {
                            value: id,
                            label: website.addons.mailchimp.lists[id]
                        };
                    });
                    website.addons.mailchimp.tags = website.addons.mailchimp.tags.map(tag => {
                        return {
                            value: tag,
                            label: tag
                        };
                    });
                }

                this.setState({
                    model: model,
                    pages: pagesList,
                    settings: {
                        mailchimp: website.addons.mailchimp
                    },
                    loading: false,
                    isEdit: model.id ? true : false
                })
            });
    }

    fields = () => {
        let fields = [{
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Form.Form.title",
                    type: "text",
                    name: 'title',
                    customFeedback: FormFormError,
                    formErrorName: "title"
                }
            ]
        },
        {
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Form.Form.pages",
                    placeholder: <FormattedMessageString id="CMS.Form.Form.pages.placeholder" />,
                    type: "select",
                    multi: true,
                    name: "pages",
                    options: this.state.pages ? this.state.pages : [],
                    customFeedback: FormFormError,
                    formErrorName: "pages"
                }
            ]
        },
        {
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Form.Form.button_text",
                    type: "text",
                    name: 'button_text',
                    customFeedback: FormFormError,
                    formErrorName: "button_text"
                }
            ]
        }];

        if (this.state.settings.mailchimp.enabled) {
            fields.push({
                type: "col",
                md: 12,
                fields: [{
                    title: "CMS.Form.Form.mailchimp",
                    type: "switch",
                    name: 'mailchimp',
                    customFeedback: FormFormError,
                    formErrorName: "mailchimp",
                    onChange: (e) => {
                        let model = this.state.model;
                        model.mailchimp = e.target.checked;
                        this.setState({ model: model });
                    }
                }]
            });

            if (this.state.model.mailchimp) {
                /*fields.push({
                    type: "col",
                    md: 12,
                    fields: [{
                        title: "CMS.Form.Form.mailchimp_new_list",
                        type: "switch",
                        name: 'mailchimp_new_list',
                        customFeedback: FormFormError,
                        disabled: this.state.isEdit && this.state.model.mailchimp_existing_list,
                        formErrorName: "mailchimp_new_list",
                        onChange: (e) => {
                            let model = this.state.model;
                            model.mailchimp_new = e.target.checked;
                            this.setState({ model: model });
                        }
                    }]
                });*/

                /*if (!this.state.model.mailchimp_new) {
                    fields.push({
                        type: "col",
                        md: 12,
                        fields: [{
                            title: "CMS.Form.Form.mailchimp_existing_list",
                            type: "select",
                            optional: true,
                            name: "mailchimp_existing_list",
                            clearable: true,
                            options: this.state.settings.mailchimp.lists ? this.state.settings.mailchimp.lists : [],
                            customFeedback: FormFormError,
                            formErrorName: "mailchimp_existing_list"
                        }]
                    });
                }*/

                fields.push({
                    type: "col",
                    md: 12,
                    fields: [
                        {
                            title: "CMS.Form.Form.mailchimp_double_optin",
                            type: 'switch',
                            name: 'mailchimp_double_optin',
                            optional: true,
                            customFeedback: FormFormError,
                            formErrorName: "mailchimp_double_optin"
                        }
                    ]
                });

                fields.push({
                    type: "col",
                    md: 12,
                    fields: [
                        {
                            title: "CMS.Form.Form.mailchimp_tags",
                            type: 'select-creatable', //"tags",
                            name: 'mailchimp_tags',
                            options: this.state.settings.mailchimp.tags ? this.state.settings.mailchimp.tags : [],
                            multi: true,
                            clearable: true,
                            optional: true,
                            customFeedback: FormFormError,
                            formErrorName: "mailchimp_tags"
                        }
                    ]
                });
            }
        }

        fields.push({
            type: "col",
            md: 12,
            fields: [],
            custom: StandardTextFormEditorComponent,
            customProps: { label: 'CMS.Form.Form.success_message', placeholder: 'CMS.Form.Form.success_message.placeholder', valueField: 'success_message' }
        }, {
            type: "col",
            md: 12,
            fields: [],
            custom: FormFieldFormComponent,
            customProps: { model: this.state.model, parent: this }
        });

        return [{
            type: "row",
            children: fields
        }];
    }

    render() {
        if (this.state.loading) return <p>loading...</p>;

        return (
            <StandardFormComponent
                {...this.props}
                ref={this.table_ref}
                parent={this}
                className="Form"
                validationSchema={Form.schema_add(this.state.model)}
                model={this.state.model}
                formSubmit={(values, formikActions) => {
                    values.mailchimp_list = values.mailchimp_existing_list || null;

                    if (this.state.isEdit) {
                        values.action = 'form';
                        return FormRepository.updateForm(values, this.props.match.params.language)
                            .then(() => {
                                FormToastComponent.successTrans("Forms", "Default.saved");
                                this.props.history.push('/forms/overview');
                            })
                            .catch(error => {
                                FormHelper.handleSubmitError(this, error)
                            })
                    } else {
                        return FormRepository.create(values)
                            .then(() => {
                                FormToastComponent.successTrans("Forms", "Default.saved");
                                this.props.history.push('/forms/overview');
                            })
                            .catch(error => {
                                FormHelper.handleSubmitError(this, error)
                            })
                    }
                }}
                formErrors={this.state.form_errors}
                fields={this.fields()}
            />
        );
    }
}

export default withRouter(FormFormComponent);